<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.vuestore.replaceState(Object.assign({}, this.vuestore.state, JSON.parse(sessionStorage.getItem("store"))))
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.vuestore.state))
    })
  }
}
</script>

<style>
body {
  font-family: Microsoft YaHei, PingFang SC, Arial, Hiragino Sans GB, sans-serif !important;
  margin: 0;
  padding: 0;
}


input,
select,
textarea,
button {
  font-family: Microsoft YaHei, PingFang SC, Arial, Hiragino Sans GB, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue